import { render, staticRenderFns } from "./ElectronicAdvantages.vue?vue&type=template&id=9e7829c6&scoped=true"
import script from "./ElectronicAdvantages.vue?vue&type=script&lang=js"
export * from "./ElectronicAdvantages.vue?vue&type=script&lang=js"
import style0 from "./ElectronicAdvantages.vue?vue&type=style&index=0&id=9e7829c6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7829c6",
  null
  
)

export default component.exports